import { useQuery } from "@apollo/client";
import { useJsonForms, withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useEffect, useMemo, useState } from "react";
import { GET_FULFILLMENT_RULES } from "../../rewards/fullfillmentRules/graphql/fulfillmentQueriesAndMutations";
import "../partnerSelect/partnerSelect.scss";

export const FulfillmentSelectComponent = (props) => {
  const { handleChange, label, path, required, visible, data, uischema, enabled } =
    props;
  const ctx = useJsonForms();
  const jsonformState = ctx?.core?.data;

  const [selected, setSelected] = useState(undefined);
  const legacyReturnArray = uischema?.returnArray;

  const {
    returnArray,
    queryVariables = {},
    filterField,
    filterKey,
    filterValue,
  } = uischema?.options || {};
  const shouldReturnArray = legacyReturnArray || returnArray;
  const resolvedFilterValue = filterKey ? jsonformState?.[filterKey] : filterValue;

  const { data: apiList } = useQuery(GET_FULFILLMENT_RULES, {
    variables: { offset: 0, limit: 100, ...queryVariables },
  });

  const fulfillmentRules = useMemo(
    () =>
      (apiList?.getFulfillmentRules?.items || []).filter((rule) => {
        if (!filterField || !resolvedFilterValue) {
          return true;
        }

        return String(rule?.[filterField] || "") === String(resolvedFilterValue);
      }),
    [apiList, filterField, resolvedFilterValue]
  );

  const formatOptions = useMemo(
    () => (options) =>
      options.map((option) => ({
        id: option.id,
        displayText: option.name,
      })),
    []
  );

  useEffect(() => {
    if (data) {
      const dataValue = Array.isArray(data) ? data[0] : data;
      const selectedFulfillmentRule = formatOptions(fulfillmentRules).find(
        (rule) => rule.id === dataValue
      );
      if (selectedFulfillmentRule) {
        setSelected([selectedFulfillmentRule]);
      }
    }
  }, [data, fulfillmentRules, formatOptions]);

  const handleSelectValue = (val) => {
    if (val) {
      setSelected(val[0].index);
      const value = shouldReturnArray ? [val[0].id] : val[0].id;
      handleChange(path, value);
    } else {
      setSelected(null);
      const value = shouldReturnArray ? [] : null;
      handleChange(path, value);
    }
  };

  return visible ? (
    <div className="partner-select-component multiple-select-wrap">
      <Dropdown
        childList={formatOptions(fulfillmentRules)}
        selection="single"
        label={label}
        disabled={
          enabled === false ||
          uischema?.readOnly ||
          uischema?.readonly ||
          uischema?.disabled ||
          uischema?.options?.readonly ||
          uischema?.options?.disabled
        }
        selectedValue={selected}
        isRequired={required}
        setSelectedValue={handleSelectValue}
        placeholder={uischema?.placeholder || "Select Fulfillment Rule"}
      />
    </div>
  ) : null;
};

export const FulFillmentSelectControl = withJsonFormsMultiEnumProps(
  FulfillmentSelectComponent
);
